import React, { useContext, useEffect, useRef, useState } from "react";
import './Linkage.css';
import {
    urlApiServer,
    urlApiServerImage,
    urlMailerSend,
    mailerCompanyEmail,
    mailerWebsiteSingefin,
    mailerLinkageType,
    mailerLinkageSubject,
} from "../../Component/Config/Config";
import SignatureCanvas from 'react-signature-canvas';
import LoginContext from "../../Component/Context/LoginContext";
import Swal from "sweetalert2";
import logo from '../../Assest/LogoSingefin.png'

function buildLinkageEmailMessage(fields) {
    const ref =
        fields.youWereReferred === "yes"
            ? "Sí"
            : fields.youWereReferred === "no"
              ? "No"
              : fields.youWereReferred || "—";
    return [
        "Nueva solicitud de vinculación (Singefin)",
        "",
        `Nombres: ${fields.name}`,
        `Apellidos: ${fields.surnames}`,
        `Cédula: ${fields.confirmationOfidCardrd}`,
        `Fecha de nacimiento: ${fields.birthdayDate}`,
        `Empresa actual: ${fields.companyWhereYouWork}`,
        `Cargo actual: ${fields.currentPosition}`,
        `Ciudad: ${fields.city}`,
        `Departamento: ${fields.department}`,
        `Celular: ${fields.phone}`,
        `Correo: ${fields.email}`,
        `¿Fuiste referido?: ${ref}`,
        `Nombre referido: ${fields.referralName || "—"}`,
        `Fecha de afiliación: ${fields.dateOfAffiliation}`,
        "",
        `Firma digital (archivo adjunto): ${fields.fileName}`,
    ].join("\n");
}

/**
 * El mailer suele responder JSON ({ success, message }); a veces texto plano en errores.
 */
/** Texto legible para SweetAlert si el mailer devuelve HTML de error. */
function shortMailerUserMessage(msg, status) {
    const s = String(msg || "");
    if (s.includes("<!DOCTYPE") || s.includes("<html") || s.includes("Internal Server Error")) {
        return `El servicio de correo respondió HTTP ${status} (error interno). Hay que revisar los logs del Node del mailer en el VPS; a veces falla cuando llega la cabecera Origin desde el navegador.`;
    }
    return s.length > 400 ? `${s.slice(0, 400)}…` : s;
}

function parseMailerResponse(rawBody, httpStatus) {
    const trimmed = (rawBody || "").trim();
    if (!trimmed) {
        return {
            success: false,
            message: `Sin cuerpo en la respuesta (HTTP ${httpStatus}).`,
        };
    }
    const first = trimmed[0];
    if (first === "{" || first === "[") {
        try {
            return JSON.parse(trimmed);
        } catch {
            return {
                success: false,
                message: `El servidor devolvió JSON mal formado (HTTP ${httpStatus}).`,
            };
        }
    }
    return {
        success: false,
        message: trimmed.slice(0, 500),
        _plainTextResponse: true,
        httpStatus,
    };
}

/** Depuración del FormData hacia el mailer (consola del navegador). */
function logMailerFormData(formData, label) {
    console.group(label || "[Singefin mailer] FormData");
    for (const [key, value] of formData.entries()) {
        if (value instanceof File || value instanceof Blob) {
            console.log(key, {
                kind: "File/Blob",
                name: value.name,
                size: value.size,
                type: value.type,
            });
        } else {
            console.log(key, value);
        }
    }
    console.groupEnd();
}

function showLinkageSendingProgress() {
    Swal.fire({
        title: "Enviando solicitud ...",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
            Swal.showLoading();
        },
    });
}

function Linkage() {

    const urlGetLinkage = urlApiServer + "Linkages?populate=*";
    const urlPostLinkage = urlApiServer + "linkingforms";
    const urlPostUploadLinkage = urlApiServer + "upload/";

    const sigCanvas = useRef(null);

    const [confirmationOfidCardrd, setConfirmationOfidCardrd] = useState('')
    const [city, setCity] = useState('')
    const [companyWhereYouWork, setCompanyWhereYouWork] = useState('')
    const [idCard, setIdCard] = useState('')
    const [name, setName] = useState('')
    const [surnames, setSurnames] = useState('')
    const [currentPosition, setCurrentPosition] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')
    const [birthdayDate, setBirthdayDate] = useState('')
    const [department, setDepartment] = useState('')
    const [youWereReferred, setYouWereReferred] = useState('')
    const [referralName, setReferralName] = useState('')
    const [dateOfAffiliation, setDateOfAffiliation] = useState('')
    const [data, setData] = useState([]);
    const { infoUser } = useContext(LoginContext)

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (infoUser.isLoged === true) {
            window.location.href = './Inicio';
        }
    }, [infoUser])

    useEffect(() => {
        if (infoUser.isLoged === true) {
            setName(infoUser.usuario.nombres)
            setSurnames(infoUser.usuario.apellidos)
            setIdCard(infoUser.usuario.cedula_ciudadania)
            setConfirmationOfidCardrd(infoUser.usuario.confirmacion_c_c)
            setBirthdayDate(infoUser.usuario.fecha_nacimiento)
            setCompanyWhereYouWork(infoUser.usuario.empresa_actual)
            setCurrentPosition(infoUser.usuario.cargo_actual)
            setCity(infoUser.usuario.ciudad)
            setDepartment(infoUser.usuario.departamento)
            setPhone(infoUser.usuario.celular_contacto)
            setEmail(infoUser.usuario.correo)
            setYouWereReferred(infoUser.usuario.fuiste_referido)
            setReferralName(infoUser.usuario.nombre_referido)
            setDateOfAffiliation(infoUser.usuario.fecha_afiliacion)
            // setName(infoUser.)
        }
    }, [infoUser])


    useEffect(() => {
        (async function () {
            const startHeaders = new Headers();
            startHeaders.append("Content-Type", "application/json");

            const requestOptions = {
                method: 'GET',
                headers: startHeaders,
                redirect: 'follow',
            };

            try {
                await fetch(urlGetLinkage, requestOptions)
                    .then(response => response.json())
                    .then(LinkageResponse => {
                        console.log('info del Linkage: ', LinkageResponse.data);
                        setData(LinkageResponse.data);
                    });
            } catch (error) {
                console.log('el backend esta temporalmente descativado')
            }

        })();

    }, [urlGetLinkage]);

    const clearSignature = () => {
        if (sigCanvas.current) {
            sigCanvas.current.clear();
        }
    };

    function headleNames(e) {
        setName(e.target.value); // Para un input tipo texto, usa `value`
    }

    function headleSurnames(e) {
        setSurnames(e.target.value); // Para un input tipo texto, usa `value`
    }

    function headleidCard(e) {
        setIdCard(e.target.value); // Para un input tipo número, usa `value`
    }

    function handleConfirmationOfIdCard(e) {
        const value = e.target.value;
        if (value === idCard) {
            setConfirmationOfidCardrd(value);
        } else {
            Swal.fire({
                title: "Error",
                text: "Por favor, verifica que tu cédula y este campo sean iguales",
                icon: "error",
                allowOutsideClick: false
            });
        }
    }

    function headleBirthdayDate(e) {
        setBirthdayDate(e.target.value); // Para un input tipo fecha, usa `value`
    }

    function headleCompanyWhereYouWork(e) {
        setCompanyWhereYouWork(e.target.value); // Para un input tipo texto, usa `value`
    }

    function headleCurrentPosition(e) {
        setCurrentPosition(e.target.value); // Para un input tipo texto, usa `value`
    }


    function headlecity(e) {
        setCity(e.target.value); // Para un input tipo número, usa `value`
    }


    function headleDepartment(e) {
        setDepartment(e.target.value); // Para un input tipo número, usa `value`
    }

    function headlePhone(e) {
        setPhone(e.target.value); // Para un input tipo número, usa `value`
    }

    function headleEmail(e) {
        setEmail(e.target.value); // Para un input tipo email, usa `value`
    }

    function headleYouWereReferred(e) {

        setYouWereReferred(e.target.value);

    }

    function headleReferralName(e) {
        console.log(e.target.value)
        setReferralName(e.target.value); // Para un textarea, usa `value`
    }

    function headleDateOfAffiliation(e) {
        setDateOfAffiliation(e.target.value); // Para un input tipo fecha, usa `value`
    }

    function resetLinkageForm() {
        setName("");
        setSurnames("");
        setIdCard("");
        setConfirmationOfidCardrd("");
        setBirthdayDate("");
        setCompanyWhereYouWork("");
        setCurrentPosition("");
        setCity("");
        setDepartment("");
        setPhone("");
        setEmail("");
        setYouWereReferred("");
        setReferralName("");
        setDateOfAffiliation("");
        clearSignature();
    }

    async function postFormLinkage() {
        if (!sigCanvas.current || sigCanvas.current.isEmpty()) {
            Swal.fire({
                title: "Error",
                text: "Porfavor, no olvides poner tu firma",
                icon: "error",
                allowOutsideClick: false,
            });
            return;
        }
        const signatureData = sigCanvas.current.getTrimmedCanvas().toDataURL("image/png");

        // Nombre de archivo sin espacios ni caracteres raros (algunos mailers/multipart fallan con espacios o Unicode en filename).
        const fileNameBase = `${String(name).trim()}${String(surnames).trim()}`.trim() || "firma";
        const fileName = `${fileNameBase.replace(/\s+/g, "_").replace(/[^a-zA-Z0-9._-]/g, "") || "firma"}.png`;

        const byteString = atob(signatureData.split(",")[1]);
        const arrayBuffer = new ArrayBuffer(byteString.length);
        const uintArray = new Uint8Array(arrayBuffer);
        for (let i = 0; i < byteString.length; i++) {
            uintArray[i] = byteString.charCodeAt(i);
        }
        const file = new Blob([arrayBuffer], { type: "image/png" });

        console.group("[Singefin mailer] 1 — Datos recogidos antes de enviar");
        console.log("URL envío correo:", urlMailerSend);
        console.log("formulario (texto)", {
            nombres: name,
            apellidos: surnames,
            cedula_ciudadania: confirmationOfidCardrd,
            fecha_nacimiento: birthdayDate,
            empresa_actual: companyWhereYouWork,
            cargo_actual: currentPosition,
            ciudad: city,
            departamento: department,
            celular_contacto: phone,
            correo: email,
            fuiste_referido: youWereReferred,
            nombre_referido: referralName,
            fecha_afiliacion: dateOfAffiliation,
            archivo_firma: fileName,
        });
        console.log("firma PNG", {
            fileName,
            bytes: file.size,
            type: file.type,
        });
        console.groupEnd();

        try {
            showLinkageSendingProgress();

            const uploadForm = new FormData();
            uploadForm.append("files", file, fileName);

            const linkagePayload = JSON.stringify({
                data: {
                    nombres: name,
                    apellidos: surnames,
                    cedula_ciudadania: confirmationOfidCardrd,
                    fecha_nacimiento: birthdayDate,
                    empresa_actual: companyWhereYouWork,
                    cargo_actual: currentPosition,
                    ciudad: city,
                    departamento: department,
                    celular_contacto: phone,
                    correo: email,
                    fuiste_referido: youWereReferred === "yes",
                    nombre_referido: referralName,
                    fecha_afiliacion: dateOfAffiliation,
                    firma: fileName,
                },
            });

            const mailForm = new FormData();
            mailForm.append("name", `${name} ${surnames}`.trim());
            mailForm.append("email", email);
            mailForm.append(
                "message",
                buildLinkageEmailMessage({
                    name,
                    surnames,
                    confirmationOfidCardrd,
                    birthdayDate,
                    companyWhereYouWork,
                    currentPosition,
                    city,
                    department,
                    phone,
                    email,
                    youWereReferred,
                    referralName,
                    dateOfAffiliation,
                    fileName,
                })
            );
            mailForm.append("companyEmail", mailerCompanyEmail);
            mailForm.append("website", mailerWebsiteSingefin);
            mailForm.append("type", mailerLinkageType);
            mailForm.append("subject", mailerLinkageSubject);
            mailForm.append("files", file, fileName);

            logMailerFormData(
                mailForm,
                "[Singefin mailer] 2 — FormData (mismo contrato que mailer HTTPS)"
            );

            console.log("[Singefin mailer] 3 — POST a", urlMailerSend);

            const mailRes = await fetch(urlMailerSend, {
                method: "POST",
                body: mailForm,
            });

            const rawBody = await mailRes.text();

            console.group("[Singefin mailer] 4 — Respuesta del mailer");
            console.log("HTTP", {
                status: mailRes.status,
                statusText: mailRes.statusText,
                ok: mailRes.ok,
                url: mailRes.url,
            });
            try {
                const ct = mailRes.headers.get("content-type");
                console.log("Content-Type:", ct);
            } catch {
                /* ignore */
            }
            console.log("cuerpo (texto crudo):", rawBody);
            console.groupEnd();

            const mailJson = parseMailerResponse(rawBody, mailRes.status);
            if (mailJson._plainTextResponse) {
                console.log(
                    "[Singefin mailer] 5 — Respuesta texto (no JSON):",
                    mailJson.message
                );
            } else {
                console.log("[Singefin mailer] 5 — Cuerpo JSON:", mailJson);
            }

            const mailOk = mailRes.ok && mailJson.success === true;
            console.log("[Singefin mailer] 6 — ¿Éxito lógico? (HTTP ok + success)", {
                mailOk,
                httpOk: mailRes.ok,
                successFlag: mailJson.success,
                message: mailJson.message,
            });

            if (!mailOk) {
                const hint405 =
                    mailRes.status === 405
                        ? " HTTP 405: el servidor no acepta POST en esta URL (revisa el mailer o un proxy Apache en singefin.com → deploy/apache-mailer-proxy.example.txt)."
                        : "";
                const userMsg = mailJson.message
                    ? shortMailerUserMessage(mailJson.message, mailRes.status)
                    : "";
                await Swal.fire({
                    title: "No se envió el correo",
                    text:
                        (userMsg || "") +
                        hint405 ||
                        "No se pudo enviar el correo de notificación.",
                    icon: "warning",
                    allowOutsideClick: false,
                });
                return;
            }

            const responseFile = await fetch(urlPostUploadLinkage, {
                method: "POST",
                body: uploadForm,
                redirect: "follow",
            });
            if (!responseFile.ok) {
                throw new Error("Correo enviado, pero no se pudo subir la firma al servidor.");
            }
            await responseFile.json();

            const registerRes = await fetch(urlPostLinkage, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: linkagePayload,
                redirect: "follow",
            });
            const dataPostResponse = await registerRes.json();
            if (!registerRes.ok) {
                const msg =
                    dataPostResponse?.error?.message ||
                    "Correo enviado, pero no se pudo guardar el formulario de vinculación.";
                throw new Error(msg);
            }
            console.log("dataPostResponse", dataPostResponse);

            await Swal.fire({
                title: "Correcto",
                text: "Te haz registrado correctamente, pronto obtendras la clave de ingreso",
                icon: "success",
                allowOutsideClick: false,
            });
            resetLinkageForm();
            window.location.href = "./Inicio";
        } catch (error) {
            console.error("[Singefin mailer] Error en el flujo:", error);
            const isNetwork =
                error?.name === "TypeError" &&
                String(error?.message || "").includes("fetch");
            Swal.fire({
                title: "Error",
                text:
                    (isNetwork
                        ? "No hubo respuesta (CORS o red). En producción el mailer debe enviar Access-Control-Allow-Origin para https://singefin.com, o configura proxy /mailer-send en Apache (ver deploy/apache-mailer-proxy.example.txt). En local usa npm start (setupProxy). "
                        : "") +
                    (error?.message ||
                        "Asegurate de tener toda la informacion rellenada"),
                icon: "error",
                allowOutsideClick: false,
            });
        }
    }


    return (
        <div className="containerLinkageSection">
            <div className="containerBannerLinkage">
                <div className="bannerLinkage">
                    <div
                        style={{
                            backgroundImage: data.length > 0 && data[0].imagen_portada_vinculacion?.url
                                ? `url(${urlApiServerImage}${data[0].imagen_portada_vinculacion.url})`
                                : "url('../../Assest/temporary/bannerHome.png')", // Imagen de respaldo
                            justifyContent: data.length > 0 && data[0].posicion_texto_banner === 'derecha'
                                ? 'flex-end'
                                : data.length > 0 && data[0].posicion_texto_banner === 'centro'
                                    ? 'center'
                                    : 'flex-start'
                        }}
                        className="imageBannerLinkage"
                    >
                        {data.length > 0 && data[0] ? (
                            <p className="titleBannerLinkage">
                                {data.length > 0 && data[0].titulo_portada_vinculacion ? data[0].titulo_portada_vinculacion : "..."}
                            </p>
                        ) : (
                            '...'
                        )}
                    </div>
                </div>
                <div className="containerButtonAndLogo">
                    <img src={logo} alt='logo' className="logoBanner" />
                </div>
            </div>
            <div className="containerInfoLinkageSection">
                {data.length > 0 && data[0].texto_seccion_vinculacion ? (
                    data[0].texto_seccion_vinculacion.map((item, index) => {
                        if (item.type === "paragraph") {
                            return (
                                <>
                                    {item.children.map((child, i) => {
                                        // Si el texto tiene `bold: true`, lo envolvemos en un `<strong>`
                                        return child.bold ? (
                                            <p key={i} className="titleInfoLegalSection">
                                                {child.text}
                                            </p>
                                        ) : (
                                            <p key={index} className="textInfoLinkageSection">
                                                {child.text}
                                            </p>

                                        );
                                    })}
                                </>
                            );
                        } else if (item.type === "list" && item.format === "unordered") {
                            return (
                                <ul key={index} className="textInfoLinkageSection">
                                    {item.children.map((listItem, i) => (
                                        <li key={i}>{listItem}</li>
                                    ))}
                                </ul>
                            );
                        }
                        return null;
                    })
                ) : (
                    <p className="textInfoLinkageSection">...</p>
                )}
            </div>
            <div className="containerFormLinkageSection">
                <div className="cardFormnLinkageSection">
                    <div className="containerInputsLinkageSection">
                        <input
                            type="text"
                            name="names"
                            placeholder="Nombres"
                            value={name}
                            onChange={headleNames}
                            className="inputsLinkageSection"
                        />
                        <input
                            type="text"
                            name="surnames"
                            placeholder="Apellidos"
                            value={surnames}
                            onChange={headleSurnames}
                            className="inputsLinkageSection"
                        />
                    </div>
                    <div className="containerInputsLinkageSection">
                        <input
                            type="number"
                            name="idCard"
                            placeholder="cedula"
                            value={idCard}
                            onChange={headleidCard}
                            className="inputsLinkageSection"
                        />
                        <input
                            type="number"
                            name="ConfirmationOfIdCard"
                            placeholder="Confirmar tu cédula"
                            value={confirmationOfidCardrd}
                            onBlur={handleConfirmationOfIdCard} // Asegúrate de que esté referenciada aquí
                            onChange={(e) => setConfirmationOfidCardrd(e.target.value)}
                            className="inputsLinkageSection"
                        />
                    </div>
                    <div className="containerInputsLinkageSection">
                        <div className="">
                            <p className="optionsFooter" style={{ textAlign: 'center' }}>
                                Fecha de nacimiento:
                            </p>
                            <input
                                type="date"
                                name="birthdayDate"
                                placeholder="Fecha de cumpleaños"
                                value={birthdayDate}
                                onChange={headleBirthdayDate}
                                className="inputsLinkageSection elongatedInputs"
                            />
                        </div>
                    </div>
                    <div className="containerInputsLinkageSection">
                        <input
                            type="text"
                            name="companyWhereYouWork"
                            placeholder="Empresa donde labora"
                            value={companyWhereYouWork}
                            onChange={headleCompanyWhereYouWork}
                            className="inputsLinkageSection"
                        />
                        <input
                            type="text"
                            name="currentPosition"
                            placeholder="Cargo actual"
                            value={currentPosition}
                            onChange={headleCurrentPosition}
                            className="inputsLinkageSection"
                        />
                    </div>
                    <div className="containerInputsLinkageSection">
                        <input
                            type="text"
                            name="city"
                            placeholder="Ciudad"
                            value={city}
                            onChange={headlecity}
                            className="inputsLinkageSection"
                        />
                        <input
                            type="text"
                            name="department"
                            placeholder="Departamento"
                            value={department}
                            onChange={headleDepartment}
                            className="inputsLinkageSection"
                        />
                    </div>
                    <div className="containerInputsLinkageSection">
                        <input
                            type="number"
                            name="phone"
                            placeholder="Número célular de contacto"
                            value={phone}
                            onChange={headlePhone}
                            className="inputsLinkageSection"
                        />
                        <input
                            type="email"
                            name="email"
                            placeholder="Correo electrónico"
                            value={email}
                            onChange={headleEmail}
                            className="inputsLinkageSection"
                        />
                    </div>
                    <div className="containerInputsLinkageSection">
                        <select
                            name="youWereReferred"
                            id="youWereReferred"
                            value={youWereReferred}
                            onChange={headleYouWereReferred}
                            className="inputsLinkageSection"
                        >
                            <option value="youWereReferred">Fuiste referido?</option>
                            <option value="yes">Si</option>
                            <option value="no">No</option>

                        </select>
                        <input
                            type="text"
                            name="referralName"
                            placeholder="Nombre de referido"
                            value={referralName}
                            onChange={headleReferralName}
                            className="inputsLinkageSection"
                        />
                    </div>
                    <div className="containerInputsEndLinkageSection">
                        <div className="containerInputsLinkageSection">
                            <div className="">
                                <p className="optionsFooter" style={{ textAlign: 'center' }}>
                                    Tu fecha de afiliación establecida es:
                                </p>
                                <input
                                    type="date"
                                    name="dateOfAffiliation"
                                    placeholder="Tu fecha de afiliación establecida es:"
                                    value={dateOfAffiliation}
                                    onChange={headleDateOfAffiliation}
                                    className="inputsLinkageSection elongatedInputs"
                                />
                            </div>
                        </div>
                        <div className="containerSignature">
                            <p className="optionsFooter" style={{ textAlign: 'center' }}>
                                Firma:
                            </p>
                            <SignatureCanvas
                                ref={sigCanvas}
                                penColor="black"
                                canvasProps={{
                                    className: 'signatureLinkageSection',
                                }}
                            />
                            <div className="containerButtonSignature">
                                <div className="cleaningAndSaveButton" onClick={clearSignature}>
                                    <p className="textCleaningAndSaveButton">
                                        LIMPIAR FIRMA
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="buttonFormLinkage" onClick={postFormLinkage}>
                        <p className="textFormLinkage">ENVIAR</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Linkage;
